/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Feature_Free_Personal_SpaceInputs */



/**
* | output |
* | --- |
* | "Personal space & project for your files" |
*
* @param {Plan_Feature_Free_Personal_SpaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_free_personal_space = /** @type {((inputs?: Plan_Feature_Free_Personal_SpaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Free_Personal_SpaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Persönlicher Space & Projekt für deine Dateien")
	return /** @type {LocalizedString} */ ("Personal space & project for your files")
});